import { Injectable, inject } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { keysToTranslate } from '@core/util/keys-to-translate';
import { TranslateService } from '@ngx-translate/core';

/**
 * Provides default validation messages to nested FormControlComponents.
 */
@Injectable()
export class ValidationMessageService {
  protected translate = inject(TranslateService);

  public constructor() {
    keysToTranslate([
      '{{label}} required',
      '{{label}} must be a valid date of the form 31.12.2018',
    ]);
  }

  public messagesFor(label: string, errors: ValidationErrors) {
    const messages: string[] = [];
    for (const type in errors) {
      if (errors.hasOwnProperty(type)) {
        messages.push(this.messageFor(label, type));
      }
    }
    return messages;
  }

  protected messageFor(label: string, type: string): string {
    switch (type) {
      case 'required':
        return this.translate.instant('{{label}} required', { label });
      case 'ngbDate':
        return this.translate.instant('{{label}} must be a valid date of the form 31.12.2018', {
          label,
        });
      default:
        throw new Error('missing message for validator of type ' + type);
    }
  }
}
